export default "__VITE_ASSET__BWEwSAW9__"